<div *ngIf="hasContent || (editModeSet && !isRegionalManager)" class="section">
  <div class="section__header">
    <h2 class="section__header-text">Fuel Prices</h2>
    <button id="add_btn" (click)="openEditFuelDialog(null)" mat-mini-fab *ngIf="editModeSet && !isRegionalManager">
      <mat-icon aria-label="Add Contact">add</mat-icon>
    </button>
  </div>
  <div class="section__body">
    <table class="data-block">
      <thead>
        <tr>
          <th class="data-block__label">Type</th>
          <th class="data-block__label">Fee</th>
          <th class="data-block__label">Service</th>
          <th class="data-block__label">Updated</th>
          <th class="data-block__label">Note</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bf of business.fuel; let i = index" class="data-block__item">
          <td class="data-block__value">
            <mat-icon (click)="openEditFuelDialog(i)" *ngIf="(bf.sourceId === 6 || bf.sourceId === 11 || bf.sourceId === 3) && (editModeSet && !isRegionalManager)" class="edit-icon" mat-tooltip="Edit" aria-label="Button that opens popover that allows you to edit fuel">edit</mat-icon>
            <mat-icon (click)="deleteFuel(i)"  *ngIf="(bf.sourceId === 6 || bf.sourceId === 11 || bf.sourceId === 3) && (editModeSet && !isRegionalManager)" class="delete-icon" mat-tooltip="Delete" aria-label="Button deletes fuel row">delete_outline</mat-icon>
            {{ GetFuelType(bf.fuelType) }} <ng-container *ngIf="bf.fuelBrand && bf.fuelBrand !== 'Unknown'">({{ bf.fuelBrand }})</ng-container>
          </td>
          <td class="data-block__value">{{ bf.price | currency: 'USD' }}</td>
          <td class="data-block__value">{{ GetServiceType(bf.service) }}</td>
          <td class="data-block__value">{{ bf.updateDate | date:'shortDate' }}</td>
          <td class="data-block__value">
            <ng-container *ngIf="bf.otherInfo">
              {{ bf.otherInfo }}<br>
            </ng-container>
            <span class="business-fuel__source-label">Source:</span>
            <app-source [source]="bf.sourceId" [compact]="true"></app-source>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="editModeSet && !isRegionalManager; else notEditing" class="section__footer">
    <div class="business-fuel__disclaimers">
      <mat-checkbox #checkbox [checked]="isChecked(privateTag.tagId)" [id]="privateTag.tagId"
                    (change)="checkBoxChanged($event)">Fuel not available to the general public.
      </mat-checkbox><br />
    </div>
  </div>
</div>
<ng-template #notEditing>
  <div class="section__footer">
    <div class="business-fuel__disclaimers">
      <em *ngIf="hasTag(business.tags, 'Fuel::Private')">
        Fuel not available to the general public.<br />
      </em>
    </div>
  </div>
</ng-template>
